import {Component,OnInit} from '@angular/core';
import {AccueilService} from "@components/admin/bibliotheque/notifications/accueil/accueil.service";
import {FloatingButtonAction,TypeAction} from "@share/component/floating-button/floating-button";
import {BehaviorSubject} from "rxjs";


/**
 * Composant d'affichage de la liste des accueils
 *
 * @author Lionel Gimenez
 * @date 24/03/2026
 */
@Component({
    host: {'data-test-id': 'notification-accueil'},
    selector: 'notification-accueil',
    templateUrl: './notification-accueil.component.html',
    providers: [AccueilService]
})
export class NotificationAccueilComponent implements OnInit {
    /** Liste des actions possibles */
    listeActions: BehaviorSubject<Array<FloatingButtonAction>> = new BehaviorSubject<Array<FloatingButtonAction>>(null);

    /**
     * Constructeur
     *
     * @param accueilService Service de gestion des accueils
     */
    constructor(
        public accueilService: AccueilService
    ) {}

    /**
     * Hook initialisation
     */
    ngOnInit(): void {
        //Chargement de la liste
        this.accueilService.initListView();

        //Initialisation des actions possibles
        this.listeActions.next([{
            type: TypeAction.PRIMARY,
            icone: 'nio icon-ajouter',
            libelle: 'global.actions.creer',
            doAction: () => this.accueilService.create(),
        }]);
    }
}
